import { Misconception } from 'controllers/misconceptions';
import { useKyronQuery } from './kyronQuery';

export const useLessonMisconceptionsQuery = (lessonId: number) =>
  useKyronQuery<{ misconceptions: Misconception[] }>(`/lesson_misconceptions?lesson_id=${lessonId}`);
